(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7363],{

/***/ 69991:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/session-replay/[slug]",
      function () {
        return __webpack_require__(99969);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8966:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/errorMonitoringHero.07dcba1e.png","height":1982,"width":1841,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAPFBMVEX29vb7+/z19fX+/v75+fvj2f15Rf7///7s7O3z8vXn3/r39/fk2vv////////z8vP////azPzu6fvh4OP43CQBAAAAE3RSTlP+/c94/SMC/v39u6+EAkzaQ1nh9pxdjgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADhJREFUCJkFwYkBgCAMBMHlSY4Aipr+e3UGO6vddvGMzMxKI2IMWAQQ1JCkQkdChT2/Hl24u717/jlgAashtxebAAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 94490:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/loggingHero.e5bd46a4.png","height":2137,"width":1892,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAP1BMVEXq6ez39vbu7e/08/VMaXGad/X////v7vD09PT+/v7Jt/jp5PZXFf/UyfC1nPXh2fXPwPT4+fb39vjf2u349/o+gyLHAAAAFHRSTlP+R7zJACUW+v3+ZdwJsUvjfbZ4euEWGIAAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA6SURBVAiZFchJDsAgDANAA4bE3Vv8/7dWnEYasNZZBjECcDaUzLCNL1cI71LCHoiU0K/nvG2Q5NG3HzeQAdy3TpeFAAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 71853:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/sessionReplayHero.7e615733.png","height":1872,"width":1714,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAWlBMVEVMaXHUzub19PamoLTGs/bz8/Pl5ejv7/L6+vrbz/cDABbXz+2bePXq5vPn5ujq6evm5OjNy89xa31JQlvs6PL////v6f708/bv7vDq6ustJkQhHDaxrL95cJKiKi6cAAAAF3RSTlMAzyL5Qdr++Pxx/Z0X8bWFUf7++qtIdKxwtKQAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA+SURBVAiZFcEHEoAgDATAowsW7JeA/v+bjruw4bwvC6yRz+sMqg5H6Q0LubdeEJg0bg6JokLC59HMQvwmnz9prQMbQn4mfwAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 99969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./components/common/Buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(29204);
// EXTERNAL MODULE: ./components/common/CallToAction/FooterCallToAction.tsx + 1 modules
var FooterCallToAction = __webpack_require__(24035);
// EXTERNAL MODULE: ./components/common/CallToAction/OSSCallToAction.tsx
var OSSCallToAction = __webpack_require__(42698);
// EXTERNAL MODULE: ./components/common/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(5945);
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.tsx + 4 modules
var Navbar = __webpack_require__(93890);
// EXTERNAL MODULE: ./components/common/Section/Section.tsx
var Section = __webpack_require__(62223);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/20/solid/esm/QuestionMarkCircleIcon.js


function QuestionMarkCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(QuestionMarkCircleIcon);
/* harmony default export */ var esm_QuestionMarkCircleIcon = (ForwardRef);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var hi_index_esm = __webpack_require__(53854);
;// CONCATENATED MODULE: ./public/images/logo-on-dark.png
/* harmony default export */ var logo_on_dark = ({"src":"/_next/static/media/logo-on-dark.b5401b03.png","height":245,"width":246,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAARVBMVEVsN/TXyPxtOfRtOfRsN/RsN/RrNvRMaXG2m/lsNvRrNvRsN/RsN/Sqi/iigfjTw/trNfRnMPPu6P6TbPfBq/pjLPPj2fwsOB3xAAAAEHRSTlMn/qyX7NISAPr03kPE/vj+bKSZXgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAD9JREFUCJkVxkcSwCAMBLCl2oaUNSX/f2oGnQSpySxCUIvT3YDkz1zKgrzDCoNE3u+4T6LrN5UNyDw6BBfZuvxgLwLXVL2LegAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/logrocketlogofull.png
/* harmony default export */ var logrocketlogofull = ({"src":"/_next/static/media/logrocketlogofull.c93e20f9.png","height":128,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEX///////////9MaXH///9e6SF2AAAABXRSTlMVJAYAOoe6gyoAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAYSURBVAiZY2BkYGBgYGJmZmBhZGRgBDIAALoAGXSSgUwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/images/logrocketlogosmall.png
/* harmony default export */ var logrocketlogosmall = ({"src":"/_next/static/media/logrocketlogosmall.f278ddd6.png","height":96,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAHlBMVEVMaXH////////////////////////////////+/v62NmIqAAAACnRSTlMADiRjgPreN6Wl8leHfgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAACNJREFUCJljYIABRgjFwQwimdg4QRQLKys7iMfCDJaFKgEBAAbjAD53ZlTAAAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});
// EXTERNAL MODULE: ./components/common/HighlightLogo/HighlightLogo.tsx + 2 modules
var HighlightLogo = __webpack_require__(44688);
;// CONCATENATED MODULE: ./components/Competitors/ComparisonTable.tsx









function ComparisonTable(props) {
    if (!props.competitor) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "No Competitor Loaded"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "",
        children: props.competitor.sections.map((section, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between mb-2 items-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy1",
                                className: "text-white",
                                emphasis: true,
                                children: section.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(i == 0 ? "flex" : "hidden ", " items-center"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-[50px] md:w-[200px] px-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hidden md:flex",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightLogo/* HighlightLogo */.R, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: logo_on_dark,
                                                alt: "LogRocket Logo",
                                                className: "md:hidden"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-[50px] md:w-[200px] px-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: logrocketlogofull,
                                                alt: "LogRocket Logo",
                                                className: "hidden md:flex"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: logrocketlogosmall,
                                                alt: "LogRocket Logo",
                                                className: "md:hidden"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    section.rows.map((row, j)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    className: "text-copy-on-dark",
                                    children: row.feature
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_QuestionMarkCircleIcon, {
                                            className: "h-5 w-5 mr-2 text-copy-on-light "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "bg-divider-on-dark px-2 py-2 w-[50px] md:w-[200px] border-r-[1px] border-copy-on-light ".concat(j == 0 ? "rounded-tl-lg" : j == section.rows.length - 1 ? "rounded-bl-lg" : ""),
                                            children: row.highlight == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiCheckCircle */.HJi, {
                                                className: "text-copy-on-dark h-7 w-7"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex gap-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiXCircle */.VLi, {
                                                        className: "hidden md:flex text-copy-on-light h-7 w-7"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiDotsCircleHorizontal */.NtJ, {
                                                        className: "md:hidden text-copy-on-light h-7 w-7"
                                                    }),
                                                    row.highlight == 0.5 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "hidden md:flex items-center bg-copy-on-light px-3 rounded-full",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                            type: "copy4",
                                                            emphasis: true,
                                                            className: "text-copy-on-dark rounded-full",
                                                            children: "Coming soon"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "bg-divider-on-dark px-2 py-2 w-[50px] md:w-[200px] ".concat(j == 0 ? "rounded-tr-lg" : j == section.rows.length - 1 ? "rounded-br-lg" : ""),
                                            children: row.competitor ? /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiCheckCircle */.HJi, {
                                                className: "text-copy-on-dark h-7 w-7"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiXCircle */.VLi, {
                                                className: "text-copy-on-light h-7 w-7"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, "".concat(row.feature) + "".concat(j)))
                ]
            }, "".concat(section.title) + "".concat(i)))
    });
}

// EXTERNAL MODULE: ./components/Home/CompaniesReel/CompaniesReel.tsx + 5 modules
var CompaniesReel = __webpack_require__(92905);
// EXTERNAL MODULE: ./components/Home/CustomerReviewTrack.tsx
var CustomerReviewTrack = __webpack_require__(63519);
// EXTERNAL MODULE: ./components/Home/Home.module.scss
var Home_module = __webpack_require__(19350);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./public/images/features/errorMonitoringHero.png
var errorMonitoringHero = __webpack_require__(8966);
// EXTERNAL MODULE: ./public/images/features/loggingHero.png
var loggingHero = __webpack_require__(94490);
// EXTERNAL MODULE: ./public/images/features/sessionReplayHero.png
var sessionReplayHero = __webpack_require__(71853);
// EXTERNAL MODULE: ./public/images/sessionscreenshot.png
var sessionscreenshot = __webpack_require__(44667);
// EXTERNAL MODULE: ./components/Animate.tsx
var Animate = __webpack_require__(60216);
;// CONCATENATED MODULE: ./pages/session-replay/[slug].tsx






















const CompetitorComparisonPage = (param)=>{
    let { competitor  } = param;
    const [imageLoaded, setImageLoaded] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: sessionReplayHero/* default */.Z,
                alt: "Hero Background",
                className: "hidden"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: errorMonitoringHero/* default */.Z,
                alt: "Hero Background",
                className: "hidden"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: loggingHero/* default */.Z,
                alt: "Hero Background",
                className: "hidden"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden md:flex ml-10 my-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy3",
                        emphasis: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-start gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdKeyboardReturn */.Su7, {
                                    className: "h-5"
                                }),
                                " Explore highlight.io"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col xl:flex-row justify-between w-screen px-8 mx-auto lg:px-4 lg:py-28 max-w-[1200px] 2xl:max-w-[1400px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:w-[60%] flex justify-center mt-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col max-w-4xl gap-8 text-center lg:text-left",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            className: "text-white",
                                            children: [
                                                "The Open Source ",
                                                competitor.name,
                                                " alternative."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy1",
                                            className: "lg:w-3/4 text-copy-on-dark",
                                            children: competitor.subheader
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col lg:flex-row justify-start gap-4 w-full lg:w-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                    className: classnames_default()((Home_module_default()).solidButton, "min-w-[180px]"),
                                                    href: "https://app.highlight.io/?sign_up=1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        type: "copy2",
                                                        emphasis: true,
                                                        children: "Get started for free"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                    href: "/docs/general/product-features/session-replay/overview",
                                                    className: classnames_default()((Home_module_default()).hollowButton),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        type: "copy2",
                                                        emphasis: true,
                                                        children: "Read our docs"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-center mt-12 lg:mt-0 ultra:relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Animate/* AnimateFeatureHeroRight */.kg, {
                                        loaded: imageLoaded,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: "hidden lg:flex ultra:hidden right-0 object-contain top-0",
                                            src: sessionReplayHero/* default */.Z,
                                            alt: "Feature Spotlight",
                                            onLoadingComplete: ()=>setImageLoaded(true)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Animate/* AnimateFeatureHeroXL */.lp, {
                                        loaded: imageLoaded,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: "hidden ultra:flex",
                                            src: sessionscreenshot/* default */.Z,
                                            alt: "Feature Spotlight",
                                            onLoadingComplete: ()=>setImageLoaded(true)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "lg:hidden right-0 object-contain bottom-0 md:w-[500px]",
                                        src: sessionscreenshot/* default */.Z,
                                        alt: "Feature Spotlight",
                                        onLoadingComplete: ()=>setImageLoaded(true)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full mx-auto max-w-screen-2xl mt-24 lg:mt-36",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$, {
                            className: "flex flex-col gap-20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-auto max-w-[1100px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            className: "self-center text-center",
                                            children: [
                                                "How does ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-color-selected-light",
                                                    children: "highlight.io"
                                                }),
                                                " stack up?"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "px-8 max-w-[1000px] mx-auto mt-6 text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                type: "copy2",
                                                className: "text-copy-on-dark text-center",
                                                children: competitor.subHeader2
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonTable, {
                                    competitor: competitor
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OSSCallToAction/* OSSCallToAction */.N, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesReel/* CompaniesReel */.T, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).anchorFeature,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Home_module_default()).anchorHead,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    onDark: true,
                                    children: [
                                        "Don't take our word. ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/customers",
                                            children: "Read our customer review section →"
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerReviewTrack/* CustomerReviewTrack */.W, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCallToAction/* FooterCallToAction */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (CompetitorComparisonPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,6556,1228,3826,1399,5675,8250,1142,4117,3890,8558,4165,9774,2888,179], function() { return __webpack_exec__(69991); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);